{
  "el": {
    "task": {
      "actions": {
        "create": "Εργασία",
        "create_and_send": "Δημιουργία και αποστολή",
        "delete": "Διαγραφή εργασίας",
        "open_in_project": "Άνοιγμα εργασίας στο έργο",
        "remove_from_unit": "Αφαίρεση εργασίας από αυτό το ακίνητο",
        "save_as_draft": "Αποθήκευση ως πρόχειρη",
        "update": "Επεξεργασία εργασίας"
      },
      "attributes": {
        "assignments_count": "Αναθέσεις",
        "category": "Τρόπος ολοκλήρωσης",
        "created_at": "Δημιουργήθηκε",
        "description": "Περιγραφή",
        "title": "Τίτλος",
        "units": "Ακίνητα"
      },
      "categories": {
        "confirmation": "Επιβεβαίωση",
        "upload": "Ανέβασμα εγγράφου"
      },
      "categories_info": {
        "confirmation": "Ο υπεύθυνος τσεκάρει την εργασία μόλις ολοκληρωθεί.",
        "upload": "Ο υπεύθυνος πρέπει να ανεβάσει ένα έγγραφο για να ολοκληρώσει την εργασία."
      },
      "confirm": {
        "delete_body": "Η εργασία χάνεται, μαζί με κάθε ανάθεσή της: {assignments} σε {units}.",
        "delete_header": "Διαγραφή «{title}»;",
        "delete_silent": "Δεν ειδοποιείται κανείς, και οι ειδοποιήσεις που έχουν ήδη σταλεί δεν ανακαλούνται.",
        "remove_from_unit_body": "Κάθε υπεύθυνος της «{title}» στο {unit} τη χάνει. Η ίδια η εργασία και τα υπόλοιπα ακίνητά της μένουν ως έχουν.",
        "remove_from_unit_customers": "Οι πελάτες του {unit} δεν τη βλέπουν πλέον στην πύλη τους.",
        "remove_from_unit_header": "Αφαίρεση αυτής της εργασίας από {unit};"
      },
      "filters": {
        "phase_none": "Χωρίς φάση"
      },
      "labels": {
        "assignments_count": "{count} ανάθεση | {count} αναθέσεις",
        "created_by": "Δημιουργήθηκε από {name} · {date}",
        "created_on": "Δημιουργήθηκε στις {date}",
        "no_tasks": "Δεν υπάρχουν ακόμη εργασίες για αυτό το έργο.",
        "required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "set_all_assignees": "Ορισμός για τον υπεύθυνο | Ορισμός για όλους τους {count} υπευθύνους",
        "still_to_do": "{count} εκκρεμεί | {count} εκκρεμούν",
        "units_count": "{count} ακίνητο | {count} ακίνητα",
        "units_required": "Επίλεξε τουλάχιστον ένα ακίνητο"
      },
      "toasts": {
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Η εργασία διαγράφηκε",
        "remove_from_unit": "Η εργασία αφαιρέθηκε από αυτό το ακίνητο",
        "update": "Η εργασία ενημερώθηκε"
      }
    }
  }
}
